 <!-- <div style="    height: 5.5%;
    width: 100%;
    background: #f8f8f8;
    position: absolute;
    z-index: 100;
    margin-top: 3.57%;">
 <div class="toolbar-scroll" >
 <button mat-icon-button [matMenuTriggerFor]="appsMenu" style="width: fit-content;
    height: fit-content;
    border-radius: unset;
    margin-right: 10px;margin-left: 10px;">
  <mat-icon style="font-size: 25px;">apps</mat-icon>
  <span style="    margin-left: 2px;
    font-size: 1rem;
    color: #1d1d1d;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: normal;">{{selectedTopNavItem.label}}</span>
</button>
<div role="separator" class="tabcollection-separator" style="border-right: 2px solid #ccc;
    height: 20px;
    margin-right: 10px;"></div>
<mat-menu #appsMenu="matMenu" class="apps-menu-panel">
  <ul class="apps-list">
    <li *ngFor="let item of topNavItems" (click)="selectTopNavItem(item)">
      <mat-icon>{{ item.icon }}</mat-icon>
      <span>{{ item.label }}</span>
    </li>
  </ul>
</mat-menu>
          <ng-container *ngFor="let subItem of (selectedTopNavItem?.subToolbarItems || [])">
             <button
                mat-button
                class="nav-item"
                [ngClass]="{ active: currentSection === subItem.section }"
                (click)="handleNavClick(subItem)"
              >
                <mat-icon>{{ subItem.icon }}</mat-icon>
                <span>{{ subItem.label }}</span>
              </button>
          </ng-container>
        </div>
        </div> -->

<div class="outer-div">
  <div class="label-bar">
     <label i18n="@@spmsUserReg" class="textColour" style="font-size: 18px;
    font-weight: 500;">Meetings</label>

    <mat-slide-toggle 
      color="primary"
      [(ngModel)]="showLatestOnly"
      (click)="$event.stopPropagation()"
      (change)="onToggleLatestOnly($event.checked)"
      matTooltip="Show only the latest version of Meetings"
      style="transform: scale(1); font-size: 12px; margin-left: 8px; white-space: nowrap;">
      Latest Only
    </mat-slide-toggle>
     <span class="example-spacer"></span>
        <app-common-button
         
          title="Refresh"
		  icon="fas fa-sync-alt"
         [buttonId]="1111"
          [variant]="'cancel'"
          width="100%"
          padding="0rem 1rem"
          fontSize=".85rem"
          height="25px"
          (clicked)="onRefresh()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
          <app-common-button
        icon="fas fa-download"
  
           title="Download "
          [buttonId]="1111"
          [variant]="'cancel'"
          width="100%"
          padding="0rem 1rem"
          fontSize=".85rem"
          height="25px"
          (clicked)="onDownload()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>

          <app-common-button
          label="Create" 
          title="Create Meeting"
        icon="fas fa-plus-circle"
          [buttonId]="1111"
          [variant]="'cancel'"
          width="100%"
          padding="0rem 1rem"
          fontSize=".85rem"
          height="25px"
          [critical]="true"
          (clicked)="onCreate()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
  </div>
<!-- STATS -->
    <div class="summary-row">
 
    <div class="summary-card"
        [ngClass]="{ 'active-card': activeFilter === 'today' }"
        (click)="handleClick('today')"
        (dblclick)="handleDoubleClick()">
      <span class="label">Today</span>
      <span class="value">{{ todayCount }}</span>
    </div>

    <div class="summary-card"
        [ngClass]="{ 'active-card': activeFilter === 'week' }"
        (click)="handleClick('week')"
        (dblclick)="handleDoubleClick()">
      <span class="label">This Week</span>
      <span class="value">{{ thisWeekCount }}</span>
    </div>

    <div class="summary-card"
        [ngClass]="{ 'active-card': activeFilter === 'upcoming' }"
        (click)="handleClick('upcoming')"
        (dblclick)="handleDoubleClick()">
      <span class="label">Upcoming</span>
      <span class="value">{{ upcomingCount }}</span>
    </div>

    <div class="summary-card"
        [ngClass]="{ 'active-card': activeFilter === 'total' }"
        (click)="handleClick('total')"
        (dblclick)="handleDoubleClick()">
      <span class="label">Total Meetings</span>
      <span class="value">{{ totalCount }}</span>
    </div>
</div>

  @if(meetingsData.length > 0) {
    <div style="width: 100%;margin-bottom: 5%;" >
    <ag-grid-angular
      style="margin-top: 2%;height: 55vh;"
      class="ag-theme-balham"
     [rowData]="filteredMeetings"
    [defaultColDef]="defaultColDef"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    [pagination]="true"
    [paginationPageSize]="10"
    [enableBrowserTooltips]="true"
    (gridReady)="onGridReady($event)"
    [components]="components"
    [rowClassRules]="rowClassRules"
    [getRowStyle]="getRowStyle">
    </ag-grid-angular>


  </div>
}
  <!-- <div class="bulk-action-bar" *ngIf="getSelectedCount() > 0">
  <div class="bulk-action-content"> -->

    <!-- Close -->
    <!-- <button
      class="icon-btn"
      aria-label="Close selection bar"
      (click)="clearSelection()">
      ✖
    </button> -->

    <!-- Count -->
    <!-- <span class="selection-count">
      <i class="pi pi-check-circle"></i>
      {{ getSelectedCount() }} Items Selected
    </span> -->

    <!-- <div class="divider"></div> -->

    <!-- Actions -->
    <!-- <button class="action-btn" (click)="clearSelection()">
      <i class="pi pi-times"></i> Clear
    </button>

    <button class="action-btn" (click)="onMapSelected()">
      <i class="pi pi-link"></i> Map Selected
    </button>

    <button class="action-btn" (click)="onEditSelected()">
      <i class="pi pi-pencil"></i> Edit Selected
    </button>

    <button class="action-btn" (click)="onDeleteSelected()">
      <i class="pi pi-trash"></i> Delete Selected
    </button> -->

  <!-- </div>
</div> -->

</div>
